<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
          :headers="header"
          :get-data-func="getSelfVehicleList"
          title-text="个人车辆列表"
          hide-title-search
          clickable
          @click:row="getDetails($event.item)">
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop class="px-0 mx-0 text-xs-center">
                <v-tooltip left>
                  <v-btn :disabled="item.status==='2'" @click="deleteVehicleConfirm(item)" slot="activator" icon>
                    <v-icon small>$vuetify.icons.delete</v-icon>
                  </v-btn>
                  <span>删除车辆</span>
                </v-tooltip>
              </td>
            </template>
          </l-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
let reviewStatus = {
  '2': '审核拒绝',
  '1': '审核通过',
  '0': '待审核'
}
export default {
  name: 'selfVehicleList',
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '车牌号', value: 'plateNumber', align: 'left', sortable: false},
        {text: '用户账号', value: 'creator', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => time.stringify(v)},
        {text: '审核状态', value: 'status', align: 'left', f: (v) => reviewStatus[v]}
      ],
    }
  },
  methods: {
    async getSelfVehicleList ({pagination, sortStack, filterItems = [], search}) {
      console.log(pagination)
      let res = await this.$store.dispatch('vehicleRegister/getSelfVehicleList', {pagination: pagination})
      console.log(res)
      if (res.data.status === 1) {
        return {items: res.data.data.content, amount: res.data.data.totalElements}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因:' + res.data.msg})
      }
    },
    getDetails (item) {
      // console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'VehicleStatisticDetails',
          params: {
            plate: item.plateNumber,
          },
        })
      }
    },
    async deleteVehicleConfirm (item) {
      console.log(item)
      let {res, close} = await this.$L.confirm({
        title: '删除确认',
        text: '是否删除该车辆，车牌：' + item.plateNumber
      })
      if (res) {
        try {
          this.deleteVehicle(item,false)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteVehicle (item,status) {
      let ids = []
      ids.push(item.id)
      console.log(ids)
      let res = await this.$store.dispatch('vehicleRegister/deleteVehicles', {ids:ids,status:status})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '解绑成功'})
      }
      else {
        this.$L.alert('error',{msg:"删除失败,原因:"+res.data.msg})
      }
    }
  }
}
</script>
